import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
	:root {
		--accessibility-focus-ring-color: #193146;
		--accessibility-focus-ring-width: 1px;
		--accessibility-focus-ring-offset: 1px;
		--accessibility-focus-second-ring-color: #FFFFFF;
		--accessibility-focus-second-ring-width: 1px;
	}
	[data-reduced-motion="true"] * {
		animation-duration: 0.01ms !important;
		animation-iteration-count: 1 !important;
		transition-duration: 0.01ms !important;
		scroll-behavior: auto !important;
	}
	[data-high-contrast="true"] {
		*:focus-visible {
			outline: var(--accessibility-focus-ring-offset) var(--accessibility-focus-ring-color) solid !important;
			box-shadow: 0 0 0 var(--accessibility-focus-second-ring-width) var(--accessibility-focus-second-ring-color) !important;
		}
		[class*="__control"]:focus-within, [class*="Inputstyles__StyledInputWrapper"]:focus-within, [class*="-control"]:focus-within {
			outline: var(--accessibility-focus-ring-offset) var(--accessibility-focus-ring-color) solid !important;
			box-shadow: 0 0 0 var(--accessibility-focus-second-ring-width) var(--accessibility-focus-second-ring-color) !important;
		}
		[class*="__control"]:focus-within input, [class*="Inputstyles__StyledInputWrapper"]:focus-within input, [class*="-control"]:focus-within input {
			outline: none !important;
			box-shadow: none !important;
		}
		[class*="Editablestyles__EditableWrapper"] div:focus-within {
			outline-offset: calc(-1 * (var(--accessibility-focus-ring-offset) + var(--accessibility-focus-ring-width))) !important;
		}
		.navigation-sidebar *:focus-visible {
			outline: var(--accessibility-focus-second-ring-width) var(--accessibility-focus-second-ring-color) solid !important;
			box-shadow: none !important;
			outline-offset: calc(-1 * (var(--accessibility-focus-ring-offset) + var(--accessibility-focus-ring-width))) !important;
		}
		:root {
			--accessibility-focus-ring-width: 4px;
			--accessibility-focus-ring-offset: 4px;
			--accessibility-focus-second-ring-width: 4px;
		}
		.app-container {	
			.event-list .event-title span.tag, .card-header span.tag {
				color: #ffffff !important;
			}
			button[data-variant="primary"], button[data-variant="primary"] span,
			a[data-variant="primary"], a[data-variant="primary"] span,
			button.btn-primary, button.btn-primary span {
				background-color: #6F52FF !important;
				color: #ffffff !important;
			}
			button[data-variant="destructive"], button[data-variant="destructive"] span,
			a[data-variant="destructive"], a[data-variant="destructive"] span,
			button.btn-destructive, button.btn-destructive span {
				background-color: #EF4444 !important;
				color: #FFFFFF !important;
			}
			button[data-variant="secondary"], button[data-variant="secondary"] span,
			a[data-variant="secondary"], a[data-variant="secondary"] span,
			button.btn-secondary, button.btn-secondary span {
				color: #000000 !important;
			}
		}
		.navigation-sidebar {
			a[aria-selected="true"] {
				background-color: #6F52FF !important;
			}
		}

		/* Portal (booking-portal) high contrast: main nav header stays dark with light text */
		#booking-portal [data-portal-header] {
			background-color: #193146 !important;
			color: #ffffff !important;
		}
		#booking-portal [data-portal-header] *,
		#booking-portal [data-portal-header] p,
		#booking-portal [data-portal-header] span,
		#booking-portal [data-portal-header] h1,
		#booking-portal [data-portal-header] h2,
		#booking-portal [data-portal-header] h3,
		#booking-portal [data-portal-header] h4,
		#booking-portal [data-portal-header] h5,
		#booking-portal [data-portal-header] h6 {
			color: #ffffff !important;
		}
		#booking-portal [data-portal-header] *:focus-visible {
			outline: var(--accessibility-focus-ring-width) var(--accessibility-focus-second-ring-color) solid !important;
			box-shadow: none !important;
			outline-offset: var(--accessibility-focus-ring-offset) !important;
		}
		#booking-portal [data-portal-header] button,
		#booking-portal [data-portal-header] a,
		#booking-portal [data-portal-header] [role="button"] {
			color: #ffffff !important;
			border: 1px solid rgba(255, 255, 255, 0.5) !important;
		}
		#booking-portal [data-portal-header] button:hover,
		#booking-portal [data-portal-header] a:hover,
		#booking-portal [data-portal-header] [role="button"]:hover {
			background-color: rgba(255, 255, 255, 0.15) !important;
			border-color: #ffffff !important;
		}
		#booking-portal button[data-variant="primary"],
		#booking-portal button[data-variant="primary"] span,
		#booking-portal a[data-variant="primary"],
		#booking-portal a[data-variant="primary"] span {
			background-color: #6F52FF !important;
			color: #ffffff !important;
		}
		#booking-portal button[data-variant="destructive"],
		#booking-portal button[data-variant="destructive"] span,
		#booking-portal a[data-variant="destructive"],
		#booking-portal a[data-variant="destructive"] span {
			background-color: #EF4444 !important;
			color: #FFFFFF !important;
		}
		#booking-portal button[data-variant="secondary"],
		#booking-portal button[data-variant="secondary"] span,
		#booking-portal a[data-variant="secondary"],
		#booking-portal a[data-variant="secondary"] span {
			color: #000000 !important;
		}

		/* Portal detail page: header and content text contrast (exclude main nav header) */
		#booking-portal header:not([data-portal-header]) {
			background-color: #ffffff !important;
			color: #000000 !important;
			border-color: #000000 !important;
		}
		#booking-portal header:not([data-portal-header]) *,
		#booking-portal header:not([data-portal-header]) p,
		#booking-portal header:not([data-portal-header]) span,
		#booking-portal header:not([data-portal-header]) h1,
		#booking-portal header:not([data-portal-header]) h2,
		#booking-portal header:not([data-portal-header]) h3,
		#booking-portal header:not([data-portal-header]) h4,
		#booking-portal header:not([data-portal-header]) h5,
		#booking-portal header:not([data-portal-header]) h6 {
			color: #000000 !important;
		}
		#booking-portal header:not([data-portal-header]) button:not([data-variant="primary"]):not([data-variant="destructive"]),
		#booking-portal header:not([data-portal-header]) a {
			color: #000000 !important;
			border-color: #000000 !important;
		}
		#booking-portal main,
		#booking-portal section {
			background-color: #ffffff !important;
			color: #000000 !important;
		}
		#booking-portal main p,
		#booking-portal main span,
		#booking-portal main h1,
		#booking-portal main h2,
		#booking-portal main h3,
		#booking-portal main h4,
		#booking-portal main h5,
		#booking-portal main h6,
		#booking-portal section p,
		#booking-portal section span,
		#booking-portal section h1,
		#booking-portal section h2,
		#booking-portal section h3,
		#booking-portal section h4,
		#booking-portal section h5,
		#booking-portal section h6,
		#booking-portal main label,
		#booking-portal section label,
		#booking-portal main td,
		#booking-portal main th,
		#booking-portal section td,
		#booking-portal section th {
			color: #000000 !important;
		}
	}
`;
